import { TitleText } from "components/Generics";
function TitleTextView(props: any) {
  {
    /* Props is the sanity query for this page */
  }
  return <TitleText {...props}></TitleText>;
}

export default TitleTextView;
